import { writable } from 'svelte/store';

export const showResultSection = writable(false);
